<template>
    <v-simple-table dense>
        <tbody v-if="value">
            <tr>
                <th>Name</th>
                <td>{{value.name}}</td>
            </tr>
            <tr>
                <th>Code</th>
                <td>{{value.code}}</td>
            </tr>
            <tr>
                <th>Description</th>
                <td>{{value.description}}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {    
    name: "Warehouse",
    props: {
        value: Object
    }
}
</script>

<style>

</style>